import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UserDialogOptions } from '../component/dialog-box/dialog-box.component';

/*re-*/ export { UserDialogOptions }; // can also contain arbitrary translation parameters

@Injectable()
export class UserDialogService {
  constructor() {}

  private _dialogResult: Subject<boolean> = new Subject<boolean>();
  private _dialog: Subject<any> = new Subject<any>();

  currentDialog = this._dialog.asObservable();

  show(message: string, param?: UserDialogOptions | {}): Observable<boolean> {
    this._dialog.next({ message: message, param: param });
    return this._dialogResult.asObservable();
  }

  setDialogResult(result: boolean) {
    this._dialogResult.next(result);
  }

  dismiss() {
    this._dialog.next(null);
    this._dialogResult.next(false);
  }
}
